import {
  islamicGreen,
  redColor,
} from "../../../../../../common/helpers/colors";
import { AGES_HET, AGES_HOM } from "../constants";

const createHistogram = (ageData, suffix) => {
  let total = 0;
  const data = [];
  let arr;
  let empty = true;
  if (suffix === "HOM") arr = AGES_HOM;
  if (suffix === "HET") arr = AGES_HET;
  // eslint-disable-next-line no-restricted-syntax
  for (const item of arr) {
    const { name, age, value } = item;
    if (age in ageData) {
      data.push({
        age: name,
        value: ageData[age],
      });
      total += ageData[age];
      empty = false;
    } else {
      data.push({
        age: name,
        value,
      });
    }
  }

  return { data, empty, total };
};

const getFrequencyStyle = (ac, an) => {
  let freq;
  let color;
  let weight;

  if (ac && an) {
    freq = (ac / an) * 100;
    if (freq > 5) {
      color = islamicGreen;
      weight = "bold";
    } else if (freq < 0.01) {
      color = redColor;
      weight = "bold";
    }
  }
  return { color, weight };
};

const getTotalFrequencyStyle = (frequency) => {
  let freq;
  let color;
  let weight;

  if (frequency) {
    freq = frequency * 100;
    if (freq > 5) {
      color = islamicGreen;
      weight = "bold";
    } else if (freq < 0.01) {
      color = redColor;
      weight = "bold";
    }
  }
  return { color, weight };
};

export { createHistogram, getFrequencyStyle, getTotalFrequencyStyle };
